import React from 'react';
import AnnourFooter from './AnnourFooter';
//import { useMediaQuery } from 'react-responsive';

const ContactInfoPage = () => {
  /*const isTabletOrMobile = useMediaQuery({
    query: '(max-width: 1000px)',
  });*/

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-8">
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden">
              <div className="p-8">
                <h2 className="text-3xl font-bold text-cyan-900 mb-6 flex items-center justify-center">
                  <span className="mr-3">📞</span> Kontakt
                </h2>
                <div className="space-y-4">
                  <div className="flex items-center justify-between p-3 hover:bg-blue-50 rounded-lg transition-colors">
                    <div className="flex items-center text-gray-700">
                      <span className="text-xl mr-3">📱</span>
                      <span className="font-semibold">Telefon</span>
                    </div>
                    <a
                      className="text-blue-600 hover:text-blue-800 font-medium transition-colors"
                      href="tel:0049 152 594 315 15"
                    >
                      +49 152 594 315 15
                    </a>
                  </div>
                  <div className="flex items-center justify-between p-3 hover:bg-blue-50 rounded-lg transition-colors">
                    <div className="flex items-center text-gray-700">
                      <span className="text-xl mr-3">✉️</span>
                      <span className="font-semibold">Email</span>
                    </div>
                    <a
                      className="text-blue-600 hover:text-blue-800 font-medium transition-colors"
                      href="mailto:verwaltung@annour-bs.de"
                    >
                      verwaltung@annour-bs.de
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden">
              <div className="p-8">
                <h2 className="text-3xl font-bold text-cyan-900 mb-6 flex items-center justify-center">
                  <span className="mr-3">🕒</span> Öffnungszeiten
                </h2>
                <div className="space-y-4">
                  <div className="flex items-center justify-between p-3 hover:bg-blue-50 rounded-lg transition-colors">
                    <div className="flex items-center text-gray-700">
                      <span className="text-xl mr-3">📅</span>
                      <span className="font-semibold">Samstags</span>
                    </div>
                    <div className="font-medium text-cyan-800">
                      14:15 - 16:00 Uhr
                    </div>
                  </div>
                  <div className="flex items-center justify-between p-3 hover:bg-blue-50 rounded-lg transition-colors">
                    <div className="flex items-center text-gray-700">
                      <span className="text-xl mr-3">📅</span>
                      <span className="font-semibold">Montags</span>
                    </div>
                    <div className="font-medium text-cyan-800">
                      16:30 - 18:15 Uhr
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden">
            <div className="p-8">
              <h2 className="text-3xl font-bold text-cyan-900 mb-6 flex items-center justify-center">
                <span className="mr-3">📍</span>{' '}
                Unterrichtsaktivitätsort
              </h2>
              <div className="text-lg text-gray-700 text-center mb-6 space-y-1">
                <div>Varrentrappstraße 21</div>
                <div>38114 Braunschweig</div>
                <div>Deutschland</div>
              </div>
              <div className="rounded-lg overflow-hidden shadow-md">
                <iframe
                  className="w-full"
                  title="location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2441.0344272681277!2d10.505879477069103!3d52.27907695403838!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47aff68a22cf7deb%3A0x671a12dc58b903ff!2sVarrentrappstra%C3%9Fe%2021%2C%2038114%20Braunschweig!5e0!3m2!1sen!2sde!4v1681182134005!5m2!1sen!2sde"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <AnnourFooter />
    </div>
  );
};

export default ContactInfoPage;
